import PropTypes from 'prop-types';
import { Modal, Type } from '@mindstep-axa-dmhi/dmhi-frontend-components';
import useTranslate from '../../../../hooks/use-translate';

function RecommendationModal({
  isOpen,
  toggle,
  title,
  content,
}) {
  const { t, trans } = useTranslate([
    content,
  ]);

  return (
    <Modal open={isOpen} onClose={toggle}>
      <div>
        <Type variant="h2">{t(title)}</Type>
        <div className="flex flex-col gap-6 mt-4">
          <p>{trans[content]}</p>
        </div>
      </div>
    </Modal>
  );
}

RecommendationModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
};

export default RecommendationModal;
